import { useAuth } from '@griegconnect/krakentools-react-auth'
import { GriegHttpClientProvider } from '@griegconnect/krakentools-react-http'
import React, { useCallback } from 'react'

export type HttpWrapperProps = {
  children: React.ReactNode
}

export const HttpWrapper = (props: HttpWrapperProps) => {
  const { children } = props
  const { getTokenSilently } = useAuth()

  const getBearerToken = useCallback(() => {
    return new Promise<string>((resolve, reject) => {
      getTokenSilently().then((token: string | undefined) => {
        if (token) {
          resolve(token)
        } else {
          reject()
        }
      })
    })
  }, [getTokenSilently])

  return <GriegHttpClientProvider onGetBearerToken={getBearerToken}>{children}</GriegHttpClientProvider>
}

export default HttpWrapper
